import { Item, ItemLink, Section, MenuTitleSmall } from '../../../shared-menus';
import { useFrontPageConfig, showScreener } from '@upright/ui/views/home-views/front-page-config';
import { FeatureId } from '@upright/common/iam/access/feature-access/types';
import { useHasAccessToFeature } from '@upright/ui/common/generic/hooks';
import { SCREEN_COMPANIES_PATH, SCREEN_FUNDS_PATH } from '@upright/ui/common/generic/components/navigation/page-paths';

export const ScreenerBlock = () => {
  const frontPageConfig = useFrontPageConfig();
  const hasScreenerFeature = useHasAccessToFeature(FeatureId.SCREENER);
  const canShowScreener = showScreener(frontPageConfig.clientType) && hasScreenerFeature;

  return (
    <>
      <Section>
        <MenuTitleSmall>Assets</MenuTitleSmall>
        <Item>
          <ItemLink to={'/'}>Portfolios and funds</ItemLink>
        </Item>
      </Section>
      {canShowScreener && (
        <Section>
          <MenuTitleSmall>Screen</MenuTitleSmall>
          <Item>
            <ItemLink to={SCREEN_COMPANIES_PATH}>Companies</ItemLink>
          </Item>
          <Item>
            <ItemLink to={SCREEN_FUNDS_PATH}>Funds</ItemLink>
          </Item>
        </Section>
      )}
    </>
  );
};
